import React, { FC } from 'react';

import { Box, Stack } from '@mui/material';
import { FormikProps } from 'formik';

import {
  AllowancesNames,
  currency,
  decimalMaxLength,
  IAllContractShifts,
  ICounterShiftContract,
  ILongTermContractModel,
} from '@pharmaplan/common';

import RequestContractDetailsCard from './RequestContractDetailCard';
import CustomTextField from '../../../../common/CustomTextField';
import genericClasses from '../../../../../theme/GenericClasses';
import ThemeConstants from '../../../../../theme/ThemeConstants';
import strings from '../../../../../localization';

import styles from './styles';

const { counterRed } = ThemeConstants.common;
interface IRequestContractDetails {
  formik: FormikProps<any>;
  events: {
    shifts?: Array<IAllContractShifts>;
    longTermShiftContract?: ILongTermContractModel;
    counterShiftContract?: ICounterShiftContract;
    favorite?: boolean;
    logoImage: string;
    pharmacyName: string;
    startDate: string;
    softwareName: string;
  };
  isUpdate?: boolean;
  successAction: string;
}

const RequestContractDetails: FC<IRequestContractDetails> = ({
  formik,
  events,
  isUpdate,
  successAction,
}) => {
  const { counterShiftContract, longTermShiftContract } = events ?? {};
  const { weekDayPaidHourlyRate, weekendPaidHourlyRate } = longTermShiftContract ?? {};
  const {
    weekDayPaidHourlyRate: counterWeekdayRate,
    weekendPaidHourlyRate: counterWeekendRate,
  } = counterShiftContract ?? {};

  const showProposedAllowances = isUpdate
    ? formik.values.proposedAllowance
    : formik.values?.isCounterOffer;

  const showCounterLabel = counterWeekdayRate
    && (counterWeekdayRate !== weekDayPaidHourlyRate
      || counterWeekendRate !== weekendPaidHourlyRate);

  const counterAllowanceColor = isUpdate && counterShiftContract?.counterShiftContractId
    ? counterRed
    : null;
  const counterWeekdayColor = counterWeekdayRate && (counterWeekdayRate !== weekDayPaidHourlyRate)
    ? counterRed
    : null;

  const counterWeekendColor = counterWeekendRate && (counterWeekendRate !== weekendPaidHourlyRate)
    ? counterRed
    : null;

  return (
    <Stack>
      <RequestContractDetailsCard
        successAction={successAction}
        event={events}
      />
      <Box sx={styles.fieldContainer}>
        <CustomTextField
          name={AllowancesNames.weekDayPaidHourlyRate}
          customLabelStyle={styles.labelStyle}
          label={
            showCounterLabel
              ? strings.counterWeekdayRate
              : strings.weekdayHourlyRate
          }
          formik={formik}
          placeholder={' '}
          maxLength={decimalMaxLength}
          suffix={currency}
          textColor={counterWeekdayColor}
          disabled={
            !formik.values?.isCounterOffer
            || !formik.values?.weekdays
            || isUpdate
          }
          horizontal
        />
        <CustomTextField
          name={AllowancesNames.weekendPaidHourlyRate}
          customLabelStyle={styles.labelStyle}
          maxLength={decimalMaxLength}
          label={
            showCounterLabel
              ? strings.counterWeekendRate
              : strings.weekendHourlyRate
          }
          placeholder={' '}
          textColor={counterWeekendColor}
          suffix={currency}
          disabled={
            !formik.values?.isCounterOffer
            || !formik.values?.weekends
            || isUpdate
          }
          formik={formik}
          horizontal
        />
      </Box>

      <CustomTextField
        disabled
        formik={formik}
        placeholder=" "
        label={strings.allowances}
        name="allowanceNotes"
        multiline
        maxLength={200}
        customClass={genericClasses.borderNoneTextField}
      />

      {showProposedAllowances && (
        <CustomTextField
          textColor={counterAllowanceColor}
          disabled={!formik.values.isCounterOffer || isUpdate}
          formik={formik}
          placeholder={strings.pleaseAddAllowanceIfAny}
          label={strings.proposedAllowances}
          name="proposedAllowance"
          multiline
          maxLength={200}
          customClass={genericClasses.borderNoneTextField}
        />
      )}
    </Stack>
  );
};
export default RequestContractDetails;
